import { ChangeEvent, useEffect, useState } from "react";
import { MergeWithOverwrite, InputStyle, ValidationErrorStyle } from "src/common";
import { InputLabel } from "src/components";

export type InputTextProps = MergeWithOverwrite<React.InputHTMLAttributes<HTMLInputElement>, {
  label?: string;
  value?: string;
  regex?: RegExp;
  error?: string;
  maxLength?: number;
  className?: string;
  onChange?: (value: string) => void;
  colors?: {
    background?: string;
    text?: string;
  };
}
>;

export const InputText: React.FC<InputTextProps> = ({
  label,
  error = '',
  value = '',
  regex = undefined,
  maxLength = 30,
  onChange,
  className,
  colors,
  ...props
}) => {

  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {

    let input = e.target.value;

    if (regex) {
      input = input.replace(regex, '')
    }

    setInputValue(input);
    if (onChange) onChange(input);
  }

  return (
    <div>
      {label ? <InputLabel htmlFor={props.id} disabled={props.disabled}>{label}</InputLabel> : null}
      <InputStyle
        autoComplete="off"
        type='text'
        {...props}
        id={props.id}
        onChange={handleChange}
        hasError={!!error}
        value={inputValue}
        maxLength={maxLength}
        className={className}
        colors={colors}
      />
      {error ? <ValidationErrorStyle>{error}</ValidationErrorStyle> : null}
    </div>
  );
};
